module.exports = __webpack_public_path__ + "img/CITIMYKL.a11b8161.png";